<div class="modal-overlay">
  <div class="modal-box">
    <div class="success-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16A34A" stroke-width="2.5">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </div>

    <h2 class="success-title">Your batch is being created.</h2>
    <p class="success-subtitle">We're gathering the selected documents now — this can take a few minutes for large folders. Track progress from the Manage Batches page.</p>

    <div class="modal-actions">
      <app-button variant="secondary" [fullWidth]="true" (clicked)="onCancel()">Cancel</app-button>
      <app-button variant="primary" [fullWidth]="true" (clicked)="onCreateMore()">Create more batch</app-button>
    </div>
  </div>
</div>